import { useListingQuery, useQuoteQuery } from "~graphql/generated/graphql"
import useBookingInviteWithRedirect from "~utils/use-booking-invite-with-redirect"
import usePricingPackage from "~utils/use-pricing-package"

export default function useCheckoutEntities({
    pricingPackageId,
    bookingInviteId,
    quoteId,
    listingId,
}: {
    pricingPackageId?: string | null
    bookingInviteId?: string | null
    quoteId?: string | null
    listingId: string
}) {
    const {
        pricingPackage,
        isLoading: isLoadingPricingPackage,
        error: pricingPackageError,
    } = usePricingPackage(pricingPackageId)

    const {
        bookingInvite,
        isLoading: isLoadingBookingInvite,
        error: bookingInviteError,
    } = useBookingInviteWithRedirect(bookingInviteId)

    const {
        data: quoteData,
        loading: isLoadingQuote,
        error: quoteError,
    } = useQuoteQuery({
        variables: { id: quoteId! },
        skip: !quoteId,
    })
    const quote = quoteData?.quote

    const {
        data: listingData,
        loading: isLoadingListing,
        error: listingError,
    } = useListingQuery({
        variables: { id: listingId },
        fetchPolicy: "no-cache",
    })
    const listing = listingData?.listing

    const isLoading =
        isLoadingPricingPackage ||
        isLoadingBookingInvite ||
        isLoadingQuote ||
        isLoadingListing
    const error =
        pricingPackageError ?? bookingInviteError ?? quoteError ?? listingError

    return { pricingPackage, bookingInvite, quote, listing, isLoading, error }
}
